export enum ReportStatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  GENERATED = 'GENERATED',
  CANCELED = 'CANCELED',
  DELETED = 'DELETED',
}
